import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";

export default function FooterIcons() {
  return (
    <ul className="flex flex-row items-center space-x-5">
      <li>
        <Link to="https://www.facebook.com/Mentorsity/">
          <FaFacebook className="w-[29px] h-auto text-secondary-color hover:text-[#1877F2]" />
        </Link>
      </li>
      <li>
        <Link to="https://www.instagram.com/mentorsity/">
          <FaInstagram className="w-[29px] h-auto text-secondary-color  hover:text-[#DD2A7B]  " />
        </Link>
      </li>
      <li>
        <Link to="https://www.linkedin.com/company/mentorsity/mycompany/">
          <FaLinkedin className="w-[29px] h-auto text-secondary-color hover:text-[#0077B5]" />
        </Link>
      </li>
      <li>
        <Link to="https://www.youtube.com/c/Mentorsity">
          <FaYoutube className="w-[29px] h-auto text-secondary-color hover:text-[#FF0000]" />
        </Link>
      </li>
    </ul>
  );
}
